/*
  More to Love (1+1): perechile din același brand de pe pagina de produs (markup: snippets/tuju-mtl-pairs.liquid).
  Și El Clasico (1+1 gratuit pe codul CLASICO, Real Madrid + FC Barcelona): data-any-vendor, data-code, data-campaign.

  Date de la snippet (window):
    __tujuPairA   = { id, price }  varianta afișată a produsului curent (prețul în bani)
    __tujuPairOwn = [variant ids]  variantele produsului curent; evenimentele altor produse (quick view) se ignoră
    __tujuPairMax = { id: max }    stocul cumpărabil pe variantă, -1 = nelimitat (cardul „× 2” cere minimum 2)

  „Adaugă perechea”:
    - se citește coșul (no-store); dacă nu se poate citi, nu se ghicește (altfel s-ar putea dubla produsul curent);
    - dacă produsul curent e în coș și brandul are o unitate fără pereche, se adaugă doar sugestia (o completează);
      altfel se adaugă produsul curent + sugestia, ca să se formeze o pereche nouă, la prețul arătat pe card;
    - mesajul spune reducerea apărută efectiv în coș (diferența total_discount înainte/după).
  După adăugare tema nu poate fi anunțată direct: emitterul ei e închis în closure (theme.js:2877), iar refresh-urile
  ei prin XHR pot primi din cache-ul browserului secțiunea coșului (ETag page_cache) → coș vechi până la refresh.
  Ca la Tricolorii (fcd431b): coșul și secțiunile se cer cu no-store, se înlocuiesc aceleași zone pe care le înlocuiește
  tema, iar popup-ul nativ „Adăugat în coș” se deschide cu liniile adăugate.
*/
(function () {
  if (window.__tujuPairsBound) return;
  window.__tujuPairsBound = true;

  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var busy = false;

  // Ca shop.money_format (amount_with_comma_separator + „ lei”): mii cu punct, zecimale cu virgulă.
  function money(cents) {
    var s = (Math.max(0, cents) / 100).toFixed(2).split('.');
    return s[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + s[1] + ' lei';
  }
  function setText(el, sel, text) {
    el.querySelectorAll(sel).forEach(function (n) { n.textContent = text; });
  }
  function ownsVariant(id) {
    return (window.__tujuPairOwn || []).indexOf(Number(id)) > -1;
  }

  // ---- prețurile de pe carduri și cardul „× 2” la schimbarea variantei ----
  function recalc() {
    var a = window.__tujuPairA;
    if (!a) return;
    var max = (window.__tujuPairMax || {})[String(a.id)];
    document.querySelectorAll('[data-tuju-pair]').forEach(function (card) {
      var same = card.dataset.same === '1';
      if (same) card.hidden = typeof max === 'number' && max >= 0 && max < 2;
      var b = same ? a.price : parseInt(card.dataset.price, 10);
      var pct = parseInt(card.dataset.pct, 10) || 0;
      var off = Math.floor(Math.min(a.price, b) * pct / 100);
      setText(card, '[data-pair-total]', money(a.price + b - off));
      setText(card, '[data-pair-save]', money(off));
      if (same) setText(card, '[data-pair-own]', money(a.price));
    });
  }
  document.addEventListener('product:variant-change', function (e) {
    var v = e.detail && e.detail.variant;
    if (!v || !v.id || !ownsVariant(v.id)) return;
    window.__tujuPairA = { id: v.id, price: v.price };
    recalc();
  });

  // ---- sincronizarea temei după adăugare ----
  var QC = '.quick-cart__wrapper';
  var QC_PARTS = ['.quick-cart__items', '.quick-cart__heading', '.quick-cart__footer-subtotal span', '.quick-cart__footer .quick-cart__item-discounts'];
  var BAR = '[data-free-shipping-bar]';

  function cartBase() {
    return (window.theme && theme.routes && theme.routes.cart && theme.routes.cart.base) || '/cart';
  }
  function getCart() {
    return fetch(root + 'cart.js', { cache: 'no-store', credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('cart ' + r.status);
        return r.json();
      })
      .then(function (cart) {
        if (!cart || !Array.isArray(cart.items)) throw new Error('cart');
        return cart;
      });
  }
  function sectionIdOf(sel) {
    var el = document.querySelector(sel);
    var sec = el && el.closest('[id^="shopify-section-"]');
    return sec ? sec.id.replace('shopify-section-', '') : null;
  }
  function fetchSection(id) {
    return fetch(cartBase() + '?section_id=' + encodeURIComponent(id), { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) { var box = document.createElement('div'); box.innerHTML = html; return box; });
  }

  // Bara de livrare gratuită: markup-ul vine gol, tema îl completează din JS (theme.js:8822-8866). Aceeași logică.
  function paintBar(node) {
    if (!node) return;
    var d = node.dataset;
    var rate = (window.Shopify && Shopify.currency && Shopify.currency.rate) || 1;
    var thr = Math.round(parseInt(d.threshold, 10) * rate);
    var total = parseInt(d.cartTotal, 10);
    // Prag 0 = transport gratuit la toate comenzile (campania „livrare”): direct mesajul de succes.
    if (isNaN(thr) || isNaN(total)) return;
    var thrC = thr * 100;
    var msg = node.querySelector('.free-shipping-bar__message');
    var bar = node.querySelector('.free-shipping-bar__bar');
    if (total >= thrC) {
      node.dataset.isOverThreshold = true;
      if (msg) msg.innerText = d.freeShippingSuccessMessage || '';
    } else {
      node.dataset.isOverThreshold = false;
      if (msg) {
        msg.innerHTML = (d.freeShippingPendingMessage || '')
          .replace('{' + '{ remaining_amount }' + '}', '<span class="fs-body-bold">' + money(thrC - total) + '</span>');
      }
    }
    if (bar) bar.style.setProperty('--progress-width', (total < thrC ? total / thr : 100) + '%');
    node.dataset.isLoaded = true;
  }

  function syncDrawer() {
    var id = sectionIdOf(QC);
    if (!id) return;
    fetchSection(id).then(function (box) {
      var old = document.querySelector(QC);
      var fresh = box.querySelector(QC);
      if (!old || !fresh) return;
      if (old.querySelector('.quick-cart__items') && fresh.querySelector('.quick-cart__items')) {
        // Doar zonele de date; cross-sells nu se atinge (tema își leagă acolo handlerele).
        QC_PARTS.concat([BAR]).forEach(function (sel) {
          var n = fresh.querySelector(sel);
          var o = old.querySelector(sel);
          if (n && o) o.innerHTML = n.innerHTML;
        });
        var oldBar = old.querySelector(BAR);
        var freshBar = fresh.querySelector(BAR);
        if (oldBar && freshBar) oldBar.dataset.cartTotal = freshBar.dataset.cartTotal;
      } else {
        // Coș gol → cu produse: se schimbă toată structura; cross-sells scos ca să nu rămână butoane fără handler.
        var cs = fresh.querySelector('[data-cross-sells]');
        if (cs) cs.parentNode.removeChild(cs);
        old.innerHTML = fresh.innerHTML;
      }
      paintBar(old.querySelector(BAR));
    }).catch(function () {});
  }
  function syncHeader() {
    var links = document.querySelectorAll('[data-header-cart]');
    var id = links.length && sectionIdOf('[data-header-cart]');
    if (!id) return;
    // Doar conținutul linkului, nu linkul: rămâne handlerul temei care deschide coșul.
    fetchSection(id).then(function (box) {
      var fresh = box.querySelectorAll('[data-header-cart]');
      for (var i = 0; i < links.length && i < fresh.length; i++) links[i].innerHTML = fresh[i].innerHTML;
    }).catch(function () {});
  }
  // „X în coș” de lângă butonul principal (ca handleCartItemCount, theme.js:5374).
  function syncQtyLabels(cart) {
    var a = window.__tujuPairA;
    if (!a) return;
    var q = cart.items.reduce(function (s, i) { return s + (String(i.variant_id) === String(a.id) ? i.quantity : 0); }, 0);
    document.querySelectorAll('[data-product-form] [data-cart-item-count]').forEach(function (el) {
      if (el.closest('.product-item')) return;
      el.dataset.cartItemCount = q;
      var t = el.querySelector('.item_count');
      if (t) t.textContent = q;
    });
  }

  var popupTimer = null;
  function closePopup() {
    var pop = document.querySelector('.purchase-confirmation-popup');
    if (pop) { pop.classList.remove('active'); pop.classList.remove('is-visible'); }
    document.body.classList.remove('confirmation-popup-open');
  }
  function showPopup(keys) {
    var pop = document.querySelector('.purchase-confirmation-popup');
    var inner = pop && pop.querySelector('.purchase-confirmation-popup__inner');
    if (!inner) return;
    fetch(cartBase() + '/?section_id=purchase-confirmation-popup-item', { cache: 'no-store', credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var box = document.createElement('div');
        box.innerHTML = html;
        inner.innerHTML = '';
        inner.appendChild(box);
        paintBar(inner.querySelector(BAR));
        // Secțiunea randează toate liniile din coș cu „hidden”; ca tema, se arată doar cele adăugate acum.
        keys.forEach(function (k) {
          var line = inner.querySelector('[data-product-key="' + k + '"]');
          if (line) line.classList.remove('hidden');
        });
        pop.classList.add('active');
        document.body.classList.add('confirmation-popup-open');
        // Fără is-visible, animația temei ține conținutul la opacity 0.
        requestAnimationFrame(function () { pop.classList.add('is-visible'); });
        clearTimeout(popupTimer);
        popupTimer = setTimeout(closePopup, 5000);
        inner.addEventListener('mouseover', function () { clearTimeout(popupTimer); }, { once: true });
      })
      .catch(function () {});
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.purchase-confirmation-popup__close-button')) closePopup();
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closePopup(); });

  function syncTheme(cart, addedIds) {
    try { if (window.theme) window.theme.cartData = cart; } catch (err) {}
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    syncHeader();
    syncDrawer();
    syncQtyLabels(cart);
    showPopup(cart.items
      .filter(function (i) { return addedIds.indexOf(Number(i.variant_id)) > -1; })
      .map(function (i) { return i.key; }));
  }
  // Pentru alte blocuri care adaugă în coș (bundle-ul Sorvella, raftul Black Friday): aceeași sincronizare.
  window.__tujuCart = { get: getCart, sync: syncTheme };

  // ---- „Adaugă perechea” ----
  function status(box, text) {
    var el = box && box.querySelector('[data-tuju-pairs-status]');
    if (el) el.textContent = text;
  }

  function addPair(btn) {
    var card = btn.closest('[data-tuju-pair]');
    var box = btn.closest('[data-tuju-pairs]');
    var a = window.__tujuPairA;
    if (!card || !box || !a || busy || !ownsVariant(a.id)) return;
    busy = true;
    var same = card.dataset.same === '1';
    var brand = box.dataset.vendor;
    // ",id,id," = produsele eligibile, doar la campaniile pe mai multe colecții (El Clasico, vezi tuju-mtl-pairs.liquid);
    // fără atribut (More to Love, HTML vechi din cache) se numără tot brandul, ca până acum.
    var elig = box.dataset.eligible || '';
    // Campanii pe mai multe colecții (El Clasico): orice vendor din listă; codul campaniei se aplică după adăugare.
    var anyVendor = box.dataset.anyVendor === '1';
    var code = box.dataset.code || '';
    var campaign = box.dataset.campaign || 'mtl';
    var label = btn.textContent;
    var before = 0;
    var added = [];
    btn.disabled = true;
    btn.textContent = 'Se adaugă…';
    status(box, '');

    getCart()
      .then(function (cart) {
        before = cart.total_discount || 0;
        var aId = Number(a.id);
        var aInCart = cart.items.some(function (i) { return Number(i.variant_id) === aId; });
        var brandUnits = cart.items.reduce(function (s, i) {
          var ok = (anyVendor || i.vendor === brand) && !i.selling_plan_allocation &&
            (!elig || elig.indexOf(',' + i.product_id + ',') > -1);
          return s + (ok ? i.quantity : 0);
        }, 0);
        // Produsul curent e deja în coș și brandul are o unitate fără pereche: sugestia o completează.
        var completes = aInCart && brandUnits % 2 === 1;
        added = same
          ? [{ id: aId, quantity: completes ? 1 : 2 }]
          : (completes ? [] : [{ id: aId, quantity: 1 }]).concat([{ id: Number(card.dataset.variant), quantity: 1 }]);
        return fetch(root + 'cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ items: added })
        }).then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw data;
          });
        });
      })
      .then(function () {
        // 1+1 pe cod (CLASICO): codul se aplică acum, ca reducerea din mesaj să fie cea reală (assets/tuju-auto-code.js).
        var auto = code && window.__tujuAutoCode;
        return (auto ? auto.check({ sync: false }) : Promise.resolve(null))
          .then(function (cart) { return cart || getCart(); });
      })
      .then(function (cart) {
        var delta = (cart.total_discount || 0) - before;
        card.classList.add('is-added');
        btn.textContent = '✓ Adăugat';
        status(box, delta > 0
          ? 'Adăugat în coș, cu ' + money(delta) + ' reducere.'
          : 'Adăugat în coș.');
        syncTheme(cart, added.map(function (i) { return i.id; }));
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'campaign_pair_add',
          campaign: campaign,
          brand: brand,
          pair_type: same ? 'same_product' : 'brand_product',
          items_added: added.length,
          discount_added: delta / 100
        });
        setTimeout(function () {
          card.classList.remove('is-added');
          btn.disabled = false;
          btn.textContent = label;
        }, 4000);
      })
      .catch(function (err) {
        btn.disabled = false;
        btn.textContent = label;
        status(box, (err && err.description) || 'Nu s-a putut adăuga perechea. Încearcă din nou.');
      })
      .then(function () { busy = false; });
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var btn = e.target.closest('[data-tuju-pair-add]');
    if (btn) {
      e.preventDefault();
      addPair(btn);
      return;
    }
    var nav = e.target.closest('[data-tuju-pairs-nav]');
    if (nav) {
      var track = nav.closest('.tuju-pairs__viewport').querySelector('[data-tuju-pairs-track]');
      track.scrollBy({ left: Number(nav.dataset.tujuPairsNav) * track.clientWidth * 0.8, behavior: 'smooth' });
    }
  });

  // Săgețile (doar desktop): „‹” ascunsă la început, „›” ascunsă la final. Scroll-ul nu face bubble, deci capture.
  function navState(t) {
    var vp = t.parentNode;
    vp.classList.toggle('is-scrolled', t.scrollLeft > 4);
    vp.classList.toggle('is-end', t.scrollLeft + t.clientWidth >= t.scrollWidth - 4);
  }
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (t && t.matches && t.matches('[data-tuju-pairs-track]')) navState(t);
  }, { capture: true, passive: true });
  function initNav() { document.querySelectorAll('[data-tuju-pairs-track]').forEach(navState); }
  if (document.readyState === 'complete') initNav(); else window.addEventListener('load', initNav);
})();
